import { render, staticRenderFns } from "./compareProperty.vue?vue&type=template&id=83089950&"
import script from "./compareProperty.vue?vue&type=script&lang=ts&"
export * from "./compareProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports